import { FfpCheckTraveller, PassengerFragment, TravellerFieldEnum } from '@websky/graphql';

interface PassengerWithLoyaltyCode {
	travellerId: string;
	loyaltyCode?: string;
	values: PassengerFragment['values'];
}

const checkFfpStatusVariablesFactory = (passengers: PassengerWithLoyaltyCode[]): FfpCheckTraveller[] =>
	passengers
		.filter(p => p.loyaltyCode)
		.map(({ travellerId, values, loyaltyCode }) => ({
			travellerId,
			values: [
				...values
					.filter(v => v !== null && v.type !== TravellerFieldEnum.LoyaltyNumber)
					.map(({ type, name, value }) => ({ type, name, value })),
				{ name: 'loyaltyNumber', type: TravellerFieldEnum.LoyaltyNumber, value: loyaltyCode }
			]
		}));

export default checkFfpStatusVariablesFactory;
